var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "is-full-page": true
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('b-card', {
    attrs: {
      "header": "<i class='fa fa-file-o'></i> My Profile"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-8 md-12 xs-12"
  }, [_c('table', {
    staticClass: "table table-bordered table-sm"
  }, [_c('tr', [_c('th', [_vm._v(" " + _vm._s(_vm.user.KD_ID === "5" ? 'NPWP' : _vm.user.KD_ID === "2" ? 'KTP' : _vm.user.KD_ID === "3" ? 'Paspor' : 'Lainnya') + " ")]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(_vm.user.ID_USER) + " ")])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Nama")]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(_vm.user.NM_PERUSAHAAN) + " ")])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Alamat")]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(_vm.user.AL_PERUSAHAAN) + " ")])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("No Telepon")]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(_vm.user.NO_TELP) + " ")])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Email")]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(_vm.user.EMAIL) + " ")])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Username")]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(_vm.user.USER_NAME) + " ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 md-12 xs-12"
  }, [(_vm.user.FL_CHANGE_NPWP === 'N') ? _c('button', {
    staticClass: "btn btn-warning btn-block",
    on: {
      "click": _vm.openModalEditNPWP
    }
  }, [_vm._v("Ubah NPWP "), _c('i', {
    staticClass: "fa fa-edit"
  })]) : _vm._e()])])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "hide-footer": "",
      "title": "Ubah NPWP"
    },
    model: {
      value: (_vm.modalEditNPWP),
      callback: function($$v) {
        _vm.modalEditNPWP = $$v
      },
      expression: "modalEditNPWP"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "NPWP"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:16'),
      expression: "'required|min:16'"
    }],
    attrs: {
      "title": "Nomor identitas perusahaan",
      "name": "NPWP",
      "type": "text",
      "placeholder": "Nomor identitas perusahaan"
    },
    model: {
      value: (_vm.newNpwp),
      callback: function($$v) {
        _vm.newNpwp = $$v
      },
      expression: "newNpwp"
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('NPWP')),
      expression: "errors.has('NPWP')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("\n                            " + _vm._s(_vm.errors.first('NPWP')) + "\n                        ")])], 1), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary pull-right",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.updateNPWP
    }
  }, [_vm._v("Simpan")])], 1)])])], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-418fbece","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/account/Profile.vue
// module id = 179
// module chunks = 0